import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { Auth } from '../services';

const auth = new Auth();

export const ProtectedRoute = (props) =>
  auth.isTokenValid() ? <Route {...props} /> : <Redirect to="/" />;
